import React from 'react'
import { Menu, Icon, Image, Dropdown, Label } from 'semantic-ui-react'
import logo from 'assets/logoW.png'

import './NavigationTabs.css'
import { IS_BETA } from '../../App'

import { completeName } from 'utils/clientUtils';
import IntegrationStatusContainer from '../../containers/IntegrationStatusContainer/IntegrationStatusContainer'
import { FeatureConditionalContainer } from '../../widgets/FeatureConditional'
import { EMAIL_CAMPAIGNS, PROFESSIONAL_SWITCH } from '../../constants/Features'

export const NavigationTabs = ({ activeItem, onLogOut, onClick, onRestartTour, professional, possibleProfessionals=[], changeProfessional }) => (
  <div>            
    <Dropdown icon="bars" id="mobile-nav" trigger={<Image src={logo} width="100px" />} className='link item'>
      <Dropdown.Menu>
        <Dropdown.Item
          className="navigation-calendar-button"
          name='Calendar'
          active={activeItem === 'calendar'}
          onClick={() => onClick('calendar')}
        >
          <Icon name='calendar' />
          Calendar
        </Dropdown.Item>
        <Dropdown.Item
          className="navigation-clients-button"
          name='Clients'
          active={activeItem === 'clients'}
          onClick={() => onClick('clients')}
        >
          <Icon name='users' />
          Clients
        </Dropdown.Item>
        <Dropdown.Item
          className="navigation-tags-button"
          name='Tags'
          active={activeItem === 'tags'}
          onClick={() => onClick('tags')}
        >
          <Icon name='tags' />
          Tags
        </Dropdown.Item>
        <Dropdown.Item
          className="navigation-smarttags-button"
          name='SmartTags'
          active={activeItem === 'smarttags'}
          onClick={() => onClick('smarttags')}
        >
          <Icon name='bolt' />
          SmartTags
        </Dropdown.Item>
        <Dropdown.Item
          className="navigation-settings-button"
          name='Campaigns'
          active={activeItem === 'settings'}
          onClick={() => onClick('settings')}
        >
          <Icon name='setting' />
          Settings
        </Dropdown.Item>
        <Dropdown.Item
          className="navigation-settings-button"
          name='Settings'
          active={activeItem === 'settings'}
          onClick={() => onClick('settings')}
        >
          <Icon name='setting' />
          Settings
        </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item onClick={() => onRestartTour ? onRestartTour() : null } >
          <Icon name='flag' />
          Help
        </Dropdown.Item>
        <Dropdown.Item onClick={() => onLogOut ? onLogOut() : null } >
          <Icon name='sign-out' />
          Log Out
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
    <Menu stackable secondary id="main-nav">
      <Menu.Item
      className="hero-img"
      onClick={() => onClick('calendar')}
      >
        <Image src={logo} width="100px" />
      </Menu.Item>
      <Menu.Item
      className="navigation-calendar-button"
      name='Calendar'
      active={activeItem === 'calendar'}
      onClick={() => onClick('calendar')}
      >
        <Icon name='calendar' />
        Calendar
      </Menu.Item>
      <Menu.Item
      className="navigation-clients-button"
      name='Clients'
      active={activeItem === 'clients'}
      onClick={() => onClick('clients')}
      >
        <Icon name='users' />
        Clients
      </Menu.Item>
      <Menu.Item
      className="navigation-tags-button"
      name='Tags'
      active={activeItem === 'tags'}
      onClick={() => onClick('tags')}
      >
        <Icon name='tags' />
        Tags
      </Menu.Item>
      <Menu.Item
      className="navigation-smarttags-button"
      name='SmartTags'
      active={activeItem === 'smarttags'}
      onClick={() => onClick('smarttags')}
      >
        <Icon name='bolt' />
        SmartTags
      </Menu.Item>
     <FeatureConditionalContainer requiredFeatureName={EMAIL_CAMPAIGNS}><Menu.Item
      className="navigation-campaigns-button"
      name='Campaigns'
      active={activeItem === 'campaigns'}
      onClick={() => onClick('campaigns')}
      > 
        <Icon name='bullhorn' />
      Campaigns
      </Menu.Item></FeatureConditionalContainer>
      <Menu.Item
      className="navigation-settings-button"
      name='Settings'
      active={activeItem === 'settings'}
      onClick={() => onClick('settings')}
      >
        <Icon name='setting' />
      Settings
      </Menu.Item>
      <FeatureConditionalContainer requiredFeatureName={PROFESSIONAL_SWITCH}><Menu.Item
      className="navigation-settings-button"
      name='User'>
        <Icon name='user' />
      <Dropdown 
      onChange={(e, {value}) => {
        if(value && value !== professional) {
          changeProfessional(value);
        }
      }}
      direction='left'
        className="item"
        value={professional} 
        selection options={possibleProfessionals.map(aProfessional => {
            return {
                    text:completeName(aProfessional),
                    value:aProfessional.uuid
                  }
                }
                )} />
      </Menu.Item></FeatureConditionalContainer>
      <Menu.Item >
  {IS_BETA&&<Label color='red' icon="key" content="Beta" />}
</Menu.Item>
      <Menu.Menu position='right'>
<IntegrationStatusContainer />
        <Menu.Item onClick={() => onRestartTour ? onRestartTour() : null } >
          <Icon name='flag' />
          Help
        </Menu.Item>
        <Menu.Item onClick={() => onLogOut ? onLogOut() : null } >
          <Icon name='sign-out' />
          Log Out
        </Menu.Item>
      </Menu.Menu>
    </Menu>
    
  </div>
)